import { FilterKeys, Filters, PageType } from '../pageConfig/Types';
import { PagesConfig } from '@utils/pageConfig/PagesConfigContext';

export const isCurrentFilterProductFeature = ({ filterKey }: Filters) =>
  [FilterKeys.ADDFEAT, FilterKeys.SEGFEAT].includes(filterKey);

export const isSelectedDiffWIthAppliedFilters = (pagesConfig: PagesConfig, currentPage: PageType) => {
  const { pageType, selectedFilters, appliedFilters } = pagesConfig;
  const isExplorePage: boolean = pageType === PageType.EXPLORE || pageType === PageType.OPPORTUNITY_REVIEW || pageType === PageType.TRADING_ASSISTANT;
  const selectedOptions = selectedFilters[currentPage]?.selectedFilters || [];
  const appliedOptions = appliedFilters[currentPage]?.selectedFilters || [];
  const isDiffSelectedBetweenAppliedPg = isSelectedDiffWithApplied(pagesConfig, FilterKeys.PRODUCT_GROUP);
  const pgsAppliedFilter =
    appliedOptions.find(({ filterKey }) => filterKey === FilterKeys.PRODUCT_GROUP)?.options || [];
  const isAnyProductFeatureBeenSelected =
    selectedOptions.find(({ filterKey }) => filterKey === FilterKeys.ADDFEAT || filterKey === FilterKeys.SEGFEAT)
      ?.options || [];

  // Got special condition for EXPLORE PAGE, EXPLORE PAGE ALLOW TO SELECT MULTI PG OR NOT SELECT ANY PG
  // TO DISABLE OPTION FOR EXPLORE PAGE,
  // 1. NEED TO CHECK DIFF SELECTED AND APPLIED PG
  // 2. CHECK APPLIED PGS LENGTH
  // 3, CHECK CURRENT SELECTED FILTERS GOT ANY PRODUCT FEATURE OR NOT
  return (
    (isExplorePage && isDiffSelectedBetweenAppliedPg && pgsAppliedFilter.length && !isAnyProductFeatureBeenSelected) ||
    (!isExplorePage &&
      isSelectedDiffWithApplied(pagesConfig, FilterKeys.PRODUCT_GROUP) &&
      !isAnyProductFeatureBeenSelected)
  );
};

export const isSelectedDiffWithApplied = (pagesConfig: any, filterKey: FilterKeys): boolean => {
  const currentPage: PageType = pagesConfig.pageType;
  const selectedOptions =
    pagesConfig.selectedFilters[currentPage].selectedFilters.find(
      (filter: { filterKey: FilterKeys }) => filter.filterKey === filterKey,
    )?.options ?? [];

  const appliedOptions =
    pagesConfig.appliedFilters[currentPage].selectedFilters.find(
      (filter: { filterKey: FilterKeys }) => filter.filterKey === filterKey,
    )?.options ?? [];

  return (
    !!selectedOptions &&
    !!appliedOptions &&
    (selectedOptions.some(
      (selected: { value: any }, idx: string | number) => appliedOptions[idx]?.value !== selected.value,
    ) ||
      appliedOptions.some(
        (selected: { value: any }, idx: string | number) => selectedOptions[idx]?.value !== selected.value,
      ))
  );
};
